import type { FC } from 'react';
import type { IProps } from '@/Module/Core/Model/DataModel';
import { DefaultLayoutFooter, DefaultLayoutHeader } from '@/Module/DefaultLayout/Component';
const DefaultLayoutDesktop: FC<IProps> = ({
  children
}) => {
  return <div className="flex min-h-[100vh] flex-col" data-sentry-component="DefaultLayoutDesktop" data-sentry-source-file="DefaultLayoutDesktop.tsx">
      <DefaultLayoutHeader data-sentry-element="DefaultLayoutHeader" data-sentry-source-file="DefaultLayoutDesktop.tsx" />
      <div className="flex-1">{children}</div>
      <DefaultLayoutFooter data-sentry-element="DefaultLayoutFooter" data-sentry-source-file="DefaultLayoutDesktop.tsx" />
    </div>;
};
export default DefaultLayoutDesktop;